import { ghostRef, useDrag } from '@/hooks/useTileDrag'

/** The tile following the finger or mouse during a drag; useTileDrag moves it. */
export function DragGhost() {
  const letter = useDrag((d) => d.ghost?.letter)
  if (!letter) return null
  return (
    <div
      ref={ghostRef}
      aria-hidden
      data-drag-ghost
      className="rack-tile pointer-events-none fixed top-0 left-0 z-50 flex aspect-square w-12 items-center justify-center shadow-xl"
      // The themes animate rack tiles; the dragged copy must track the pointer exactly.
      style={{ transition: 'none', willChange: 'transform' }}
    >
      {letter}
    </div>
  )
}
